import React, { useContext, useState, useEffect } from 'react';
import { AgendaContext } from '../../../contexts/AgendaContext.jsx';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@emotion/react';
// Mui components
import { Box, Button, Modal, Typography, Backdrop, Fade } from '@mui/material';
// Components
import DotLoader from '../../common/Loaders/DotLoader/DotLoader.jsx';
import ModalErrorEnviarSolicitud from './ModalErrorEnviarSolicitud.jsx';
// Icons
import IconCircleCheck from '../../../assets/icons/icon_circle-check.svg';

export default function ModalSolicitarBaja({ modalIsVisible, handleClose, consultorio }) {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const { prestadoresOsde, postSolicitud, setSolicitudProps } = useContext(AgendaContext);

  const [succesSolicitud, SetSuccesSolicitud] = useState(false);
  const [openModalError, setOpenModalError] = useState(false);

  const bodyObject = {
    cuit: prestadoresOsde?.cuit,
    tipoSolicitud: 'BAJA_CONSULTORIO',
    descripcionSolicitud: 'Baja de consultorio',
    consultorioOsde: consultorio?.consultorioOsde[0]?.consultorioId,
    proveedor: consultorio?.proveedor,
    direccionOsde: consultorio?.consultorioOsde[0]?.direccion,
    direccionExterno: consultorio?.consultorioExterno[0].direccion,
    status: 'PENDIENTE'
  };

  useEffect(() => {
    setSolicitudProps(bodyObject);
  }, []);

  const handleSolicitarBaja = async () => {
    setIsLoading(true);

    try {
      await postSolicitud();
      SetSuccesSolicitud(true);
    } catch (error) {
      setOpenModalError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSuccesSolicitud = () => {
    navigate('/prestador/dashboard');
    handleClose();
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={modalIsVisible}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}>
      <Fade in={modalIsVisible}>
        {openModalError ? (
          <ModalErrorEnviarSolicitud open={openModalError} />
        ) : !succesSolicitud && !openModalError ? (
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: { xs: 452, sm: 452 },
              bgcolor: 'white.main',
              borderRadius: '16px',
              p: 5
            }}>
            <Typography
              id="detalles"
              variant="h2"
              sx={{ display: 'flex', justifyContent: 'flex-start' }}>
              ¿Querés desconectar esta agenda?
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                marginTop: '1rem'
              }}>
              <Typography variant="h5">
                Dirección del consultorio:{' '}
                <Typography variant="boldBodyM">
                  {consultorio?.consultorioOsde[0]?.direccion}
                </Typography>
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                width: '100%',
                marginTop: '28px',
                justifyContent: 'space-around'
              }}>
              <Button
                variant="outlined"
                disabled={isLoading}
                onClick={handleClose}
                sx={{
                  width: '176px',
                  height: '3rem',
                  borderRadius: '1rem',
                  '&.Mui-disabled': {
                    borderColor: theme.palette.gray.main
                  }
                }}>
                Mejor no
              </Button>

              <Box sx={{ position: 'relative' }}>
                <Button
                  sx={{
                    width: '176px',
                    height: '3rem',
                    borderRadius: '1rem',
                    '&.Mui-disabled': {
                      backgroundColor: isLoading
                        ? theme.palette.darkBlue.main
                        : theme.palette.primary.main
                    }
                  }}
                  disabled={isLoading}
                  variant="contained"
                  onClick={handleSolicitarBaja}
                  color="primary">
                  {!isLoading && 'Sí, desconectar'}
                  {isLoading && <DotLoader size="7px" />}
                </Button>
              </Box>
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: { xs: 452, sm: 452 },
              maxHeight: '386px',
              bgcolor: 'white.main',
              borderRadius: '16px',
              p: 5
            }}>
            <Box
              component="img"
              sx={{ width: '64px', height: '64px' }}
              alt="img not found"
              src={IconCircleCheck}
            />
            <Typography
              id="detalles"
              variant="h1"
              sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '.5rem' }}>
              Desconexión solicitada
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                marginTop: '1rem',
                gap: '1rem'
              }}>
              <Typography variant="h4">Será analizada por nuestro equipo.</Typography>
              <Typography variant="h5">
                Podés realizar el seguimiento de su estado desde la página de inicio.
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                width: '100%',
                marginTop: '28px',
                justifyContent: 'center'
              }}>
              <Button
                sx={{ width: '372px', height: '3rem', borderRadius: '1rem' }}
                variant="contained"
                onClick={handleSuccesSolicitud}
                color="primary">
                Entendido
              </Button>
            </Box>
          </Box>
        )}
      </Fade>
    </Modal>
  );
}
